/* eslint-disable no-unused-vars */
export default {
  methods: {
    validateEmail: (email) => {
      if (/^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(email))
        return true;
                      
      return false;
    }
  }
};
/* eslint-enable no-unused-vars */